// A theme-aware card: header, body, optional footer.
//
// Props:
//   header — node to show in the card header (often a <CardHeader/>)
//   body   — node to render in the body
//   footer — optional node for the footer

import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

const DataCard = ({ header, body, footer }) => (
  <Container className="py-3">
    <Card className="shadow-sm">
      <Card.Header className="bg-body-tertiary">{header}</Card.Header>
      <Card.Body>{body}</Card.Body>
      {footer != null && <Card.Footer className="bg-body-tertiary">{footer}</Card.Footer>}
    </Card>
  </Container>
);

export default DataCard;
